import { themedStyled } from 'common/styles/styletron.theme';

const styles = {
  common: { display: 'flex', marginTop: '8px', marginBottom: '8px' },
};

export const Container = themedStyled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const GuestContent = themedStyled('div', {
  ...styles.common,
  flexWrap: 'wrap',
});

export const AirlineContent = themedStyled('div', {
  paddingLeft: '24px',
  display: 'flex',
});

export const AirlineContainer = themedStyled('div', {
  ...styles.common,
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const TotalContent = themedStyled('div', {
  display: 'flex',
  justifyContent: 'end',
});

export const TotalItemContent = themedStyled('div', ({ $theme }) => ({
  ...styles.common,
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: '100%',
  [$theme.mediaQuery.md]: {
    minWidth: '50%',
    maxWidth: '500px',
  },
}));
